import axios from "axios";

function getTotal(products){
    return Object.values(products).reduce(function(totalQuantity, product){
        return parseInt(totalQuantity) + parseInt(product.quantite);
    }, 0);
}

export default {
    getCart({state, commit, getters}){
        return new Promise((resolve, reject) => {
            axios.get('/panier/json')
                .then(async (response) => {
                    commit('initCart', response.data.articles)

                    let total = await getTotal(state.products)

                    commit('setTotal', total)
                    resolve(response)
                })
                .catch(function (error) {
                    reject(error)
                });
        });
    },

    add({state, commit, getters}, product){
        return new Promise((resolve, reject) => {
            axios.get('/commande/change_quantite', {params: product})
                .then(async (response) => {
                    commit('createOrUpdateProduct', product)

                    let total = await getTotal(state.products)

                    commit('setTotal', total)
                    resolve(response)
                })
                .catch(function (error) {
                    reject(error)
                });
        });
    },

    delete({state, commit, getters}, product){
        return new Promise((resolve, reject) => {
            axios.delete(`/commande/${product.article_id}`)
                .then(async (response) => {
                    commit('removeProduct', product)
                    let total = await getTotal(state.products)

                    commit('setTotal', total)
                    resolve(response)
                })
                .catch(function (error) {
                    reject(error)
                });
        });
    },
};
